import { ProductTourActionsE } from "../../../models/enums";
import { tours } from "../tours/tours";
import { triggerMouseEvent } from "./triggerMouseEvent";

/**
 * Call existed events before next step will occur
 *
 * @param {number} nextStepIndex - next step index
 * @param {{current: HTMLElement}} stepsRef - reference to the Steps element
 * @param {string} tourName - name of the current tour
 * */

export const callActionsForNextTourStep = (nextStepIndex, stepsRef, tourName) => {
    const tourElementSelectors = Object.keys(tours[tourName]);
    const updateNextStep = () => stepsRef.current.updateStepElement(nextStepIndex);

    tourElementSelectors.forEach((currentStep, currentStepIndex) => {
        const actions = tours[tourName][currentStep];

        // Apply existed actions for the next step only
        if (nextStepIndex === currentStepIndex) {
            actions?.length && actions.forEach(action => {
                try {
                    triggerMouseEvent(action.element, action.actionName);
                    updateNextStep();
                } catch (e) {
                    console.log(e);
                    return false;
                }
            });
        }
    });
};